<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">

        <div class="no-gutters row">

         <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="production-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-type-status')"
                      to="production-type-status">
              <i class="lnr-checkmark-circle btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Status Operacional
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-lot')"
                      to="production-lot">
              <i class="lnr-page-break btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Lotes
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-mold')"
                      to="production-mold">
              <i class="lnr-cog btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Moldes
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-operator')"
                      to="production-operator">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Operadores
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-type-stop')"
                      to="production-type-stop">
              <i class="lnr-hand btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Parada
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-machine')"
                      to="production-machine">
              <i class="lnr-layers btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Máquinas
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-instrument')"
                      to="production-instrument">
              <i class="lnr-strikethrough btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Instrumentos
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-process-flow')"
                      to="production-process-flow">
              <i class="pe-7s-repeat btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Fluxo de Processos
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-type-non-conformance')"
                      to="production-type-non-conformance">
              <i class="lnr-thumbs-down btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos Não Conformidade
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('production-type-restriction')"
                      to="production-type-restriction">
              <i class="lnr-heart-pulse btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Restrições
            </t-button>
          </div>





        </div>
      </div>


      <!--      <b-col v-for="relationPages in userAuth.relationPages" :key="relationPages.pageRelationId">
              {{ relationPages.pageTitle }}
            </b-col>-->

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'ProductionSettings',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
